import script from "./newsPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./newsPreview.vue?vue&type=script&setup=true&lang=js"

import "./newsPreview.vue?vue&type=style&index=0&id=03383548&scoped=true&lang=scss"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03383548"]])

export default __exports__